// extracted by mini-css-extract-plugin
module.exports = {"facts_v1":"Faktaboks_facts_v1__gS0pH","factIcon":"Faktaboks_factIcon__XJlLj","decorated":"Faktaboks_decorated__4BEdQ","facts_v2":"Faktaboks_facts_v2__pLjsp"};